import { handleApiError, showToast } from 'BreetHelpers';
import { useEnable2faEmailMutation } from 'BreetRedux';
import { useCallback } from 'react';

import { useModalApi } from './useModalApi';

export const useMfaApi = () => {
	const [enable2faEmail] = useEnable2faEmailMutation();

	const { openModalDirect, handleModalCloseAll, closeModalDirect } = useModalApi();

	const handleEmail2faActivation = useCallback(() => {
		openModalDirect({ id: 'loadingDialog', metadata: { message: 'Activating Email Two Factor Authentication' } });
		enable2faEmail()
			.unwrap()
			.then(() => {
				showToast('success', 'Email 2FA has been enabled');
				handleModalCloseAll();
			})
			.catch((e: unknown) => {
				closeModalDirect('loadingDialog');
				handleApiError(e);
			});
	}, [enable2faEmail, handleModalCloseAll, openModalDirect, closeModalDirect]);

	return {
		handleEmail2faActivation,
	};
};
